/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_Some_AppsInputs */

const en_why_listening_compare_some_apps = /** @type {(inputs: Why_Listening_Compare_Some_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some apps`)
};

const es_why_listening_compare_some_apps = /** @type {(inputs: Why_Listening_Compare_Some_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algunas apps`)
};

/**
* | output |
* | --- |
* | "Some apps" |
*
* @param {Why_Listening_Compare_Some_AppsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_some_apps = /** @type {((inputs?: Why_Listening_Compare_Some_AppsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_Some_AppsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_some_apps(inputs)
	return en_why_listening_compare_some_apps(inputs)
});